import { render, staticRenderFns } from "./bijimng.vue?vue&type=template&id=f4009e88&scoped=true"
import script from "./bijimng.vue?vue&type=script&lang=js"
export * from "./bijimng.vue?vue&type=script&lang=js"
import style0 from "./bijimng.vue?vue&type=style&index=0&id=f4009e88&prod&scoped=true&lang=css"
import style1 from "./bijimng.vue?vue&type=style&index=1&id=f4009e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4009e88",
  null
  
)

export default component.exports